import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableComment extends Layout {
    sourceComments: DataSource;
    tableComments: Table;
}
